export const CircledArrow = () => {
  return (
    <svg viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.99766 12.6703C9.30976 12.6703 12 9.98473 12 6.67264C12 3.36055 9.30976 0.670349 5.99766 0.670349C2.6856 0.670349 0 3.36055 0 6.67264C0 9.98473 2.6856 12.6703 5.99766 12.6703ZM5.99766 11.8135C3.15546 11.8135 0.856814 9.51486 0.856814 6.67264C0.856814 3.83042 3.15546 1.53177 5.99766 1.53177C8.83989 1.53177 11.1386 3.83042 11.1386 6.67264C11.1386 9.51486 8.83989 11.8135 5.99766 11.8135Z"
        fill="black"
      />
      <path
        d="M8.98676 6.66832C8.98676 6.56238 8.94992 6.47487 8.8486 6.3735L6.93228 4.40194C6.85393 4.32362 6.77563 4.28217 6.66511 4.28217C6.45779 4.28217 6.30576 4.4434 6.30576 4.65069C6.30576 4.75203 6.34723 4.85798 6.43015 4.92708L7.45739 5.90826L7.8582 6.2952L6.98757 6.26298H3.43131C3.21481 6.26298 3.03516 6.44723 3.03516 6.66832C3.03516 6.88483 3.21481 7.06913 3.43131 7.06913H6.98757L7.86277 7.04149L7.45739 7.42843L6.43015 8.40958C6.34723 8.47869 6.30576 8.58925 6.30576 8.69062C6.30576 8.89789 6.45779 9.0545 6.66511 9.0545C6.77563 9.0545 6.85393 9.01304 6.93228 8.93473L8.8486 6.95856C8.94992 6.85719 8.98676 6.76969 8.98676 6.66832Z"
        fill="black"
      />
    </svg>
  );
};
